<template>
    <form class="g pop-up-inner" :style="styleSet">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '輸入提示'"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <div class="md" v-html="content.html"></div>
                    <div
                        v-if="content.type === 'textarea'"
                        class="md"
            >
                        <div class="cp input textarea" :class="[errors.has('value')? 'is-error': '']" :data-error="errors.first('value')">
                            <textarea v-model="value" v-validate="content.validate || ''" name="value" id="value"></textarea>
                        </div>
                    </div>
                    <div
                        v-else
                        class="md"
                    >
                        <div class="cp input" :class="[content.type? content.type: 'text', errors.has('value')? 'is-error': '']" :data-error="errors.first('value')">
                            <input v-model="value" :type="content.type || 'text'" v-validate="content.validate || ''" name="value" id="value">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </form>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let $styleSet = {};

            let $content = this.content,
                _width = $content.width,
                _type = $content.type,
                _value = $content.value || '';

            if( _width && typeof _width === 'number' ) {
                $styleSet.width = _width +'px';
            }else if( _width && typeof _width === 'string') {
                $styleSet.width = _width;
            }else {
                $styleSet.width = 'auto';
            }

            if( _type === 'checkbox' && typeof _value !== 'boolean' ) {
                _value = false;
            }

            return {
                styleSet: $styleSet,
                value: _value
            }
        },
        computed: {
            btns: function(){
                let $content = this.content || {},
                    $moreBtns = $content.moreBtns || []

                let $action = {
                        text: $content.actionName || this.$t('site.status.confirm'),
                        icon: $content.actionIcon || '',
                        themes: $content.actionTheme? $content.actionTheme: 'major',
                        func: 'action',
                    },
                    $cancel = {
                        text: $content.cancelName || this.$t('site.func.popupclose'),
                        icon: $content.cancelIcon || '',
                        themes: $content.cancelTheme || '',
                        func: 'close',
                    }

                let $results = [].concat($moreBtns);

                $results.push($action);
                $results.push($cancel);

                return $results;
            },
        },
        methods: {
            sendFuncEvent: function(func){ //多 btn 功能
                let $content = this.content,
                    _value = this.value;

                $content[func](_value);
            },
            action: function(){

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {
                        let $content = this.content,
                            $_action = $content.action,
                            _value = this.value;

                        if( $content.actionStopClose !== true ) {
                            this.close();
                        }

                        $_action(_value);
                    }
                });
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        }
    }
</script>

<style scoped lang="scss">

    .pop-up-content {

        .md {

            + .md {
                margin-top: 6px;
            }

            .input {
                width: 100%;
            }

            textarea {
                height: 120px;
            }
        }
    }
</style>
